<template>
    <section class="col-12">
        <label><strong>Client Contacts </strong> ({{ site_name }})</label>
        <div class="table">
            <vue-good-table
                id="sites-client-contacts"
                ref="sites-client-contacts"
                v-if="!loading"
                :responsive="false"
                :select-options="{ enabled: false, selectOnCheckboxOnly: true, }"
                :search-options="{ enabled: false,  placeholder:'Filter'}"
                @on-selected-rows-change="selectionChanged"
                @on-cell-click="onCellClick"
                :sort-options="{
                    enabled: false,
                    initialSortBy: {field: columns[0].field, type: 'asc'}
                  }"
                :columns="columns"
                :rows="rows">
                <div slot="table-actions" v-if="!readonly">
                    <div class="btn-group">
                        <button type="button" @click="addRowBlank" title="Manual Add"
                                class="btn btn-success" style="font-size: 10px;"><i
                            class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
                <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field === 'to'"><input @change="validateEmails()" type="checkbox"
                                                                   v-model="selecteds"
                                                                   :value="props.row.email"></div>
                    <div v-else-if="props.column.field === 'cc'"><input @change="validateEmails(true)" type="checkbox"
                                                                        v-model="selecteds_cc"
                                                                        :value="props.row.email"></div>
                    <div v-else-if="props.column.field === 'designation'" :title="props.row.designation">
                        {{ props.row.designation_short }}
                    </div>
                    <div v-else-if="props.column.field === 'email' && !props.row.id">
                        <div class="form-group" :class="!rows[props.index].valid ? 'has-error' : 'has-success'">
                            <input type="email" @keyup="validateEmails(true, rows[props.index].email)"
                                   class="form-control "
                                   v-model="rows[props.index].email">
                        </div>
                        <span @click="removeRow(props.index)"
                              title="Remove row"
                              class="fa fa-trash text-danger m-remove-row"></span>
                    </div>
                    <span v-else> {{ props.formattedRow[props.column.field] }}</span>
                </template>
            </vue-good-table>
            <!-- Modal -->
            <input v-for="row in rows" type="hidden" :name="name+'[]'" :key="row.id" :value="row.id">
        </div>
    </section>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import SiteModel from "../../../models/SiteModel";

export default {
    name: "SiteClientContact",
    props: {
        siteId: {
            required: true
        },
        name: {
            type: String,
            default: 'test'
        },
        types: {
            type: Array,
            default: () => []
        },
        readonly: {
            type: Boolean,
            default: false
        },
    },

    components: {
        VueGoodTable,
    },
    data() {
        return {
            columns: [
                {
                    label: 'To',
                    field: 'to',
                    sortable: false
                },
                {
                    label: 'CC',
                    field: 'cc',
                    sortable: false
                },
                {
                    label: 'Email',
                    field: 'email'
                },
                {
                    label: 'Designation',
                    field: 'designation'
                },
                {
                    label: 'Name',
                    field: 'name'
                },
                {
                    label: 'Phone',
                    field: 'phone'
                },
            ],
            rows: [],
            ids: [],
            selecteds: [],
            selecteds_cc: [],
            showTable: true,
            loading: true,
            messageId: null,
            site_name: '',
            validating: false,
            validated: true,
        };
    },
    watch: {
        selecteds(val) {
            //this.$refs[this.name].value = val.join(";");
        },
        selecteds_cc(val) {
            // this.$refs[this.name + '_cc'].value = val.join(";");
        }
    },
    async mounted() {
        await this.getContacts()
        this.$root.addTypeButton();
    },
    methods: {
        removeRow(index) {
            this.rows[index]['deleted'] = true;
            this.rows = this.rows.filter(function (item) {
                return !item.hasOwnProperty('deleted')
            })
        },
        isValidEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        },
        async validateEmails(cc = false, emailCc = "") {
            if (this.validating) return;
            this.validating = true;
            let validEmails = this.rows.map(e => e.email)
            if (cc) {
                this.selecteds = await this.selecteds.filter(item => !this.selecteds_cc.includes(item))
                if (emailCc) {
                    this.selecteds_cc.push(emailCc)
                }
            } else {
                this.selecteds_cc = this.selecteds_cc.filter(item => !this.selecteds.includes(item))

            }
            this.selecteds_cc = this.selecteds_cc.filter(item => validEmails.includes(item))
            this.selecteds = this.selecteds.filter(item => validEmails.includes(item))


            for (let i = 0; i < this.rows.length; i++) {
                this.rows[i]['valid'] = this.isValidEmail(this.rows[i].email)
            }


            this.validating = false;
        },
        addRowBlank() {
            this.rows.push({
                client_contact_id: '',
                email: "",
                id: null,
                name: "-",
                phone: "-",
                designation_short: "",
                valid:false
            })
            this.selecteds_cc.push("")
        },
        tdClassFunc(row) {
            return this.trCondition(row);
        },
        onCellClick(params) {
            // params.row - row object
            // params.column - column object
            // params.rowIndex - index of this row on the current page.
            // params.event - click event
        },
        async getContacts() {
            let app = this;
            await axios.get(`/sites/${this.siteId}/client-contact-list`).then((response) => {
                let i = 0;
                app.rows = response.data.rows.map((e) => {
                    let intersection = e.types.filter(x => app.types.includes(x));
                    if (intersection.length > 0) {
                        app.selecteds.push(e.email);
                        e['originalIndex'] = i;
                        e['vgt_id'] = i;
                        e['vgtSelected'] = true;
                    }
                    i++;
                    return e;
                });
                app.site_name = response.data.site_name

            })
                .catch((err) => {
                    showMessage('e', 'Error loading contacts');
                    console.error(err);
                })

            this.$root.addTypeButton();

            app.loading = false

        },
        selectionChanged(params) {
            // params.selectedRows - all rows that are selected (this page)
            this.selecteds = params.selectedRows.map((e) => e.email)
        },
    }
}
</script>

<style>
.vgt-table td, .vgt-table th {
    padding: 2px !important;
    font-size: 12px;
}

#vgt-table {
    min-height: 100px;
}

.m-remove-row {
    float: right;
    margin-right: -10px;
    margin-top: -20px;
    cursor: pointer;
}

</style>
